module.exports = __webpack_public_path__ + "static/media/qr-code-how-to.8f548661.png";